import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  page: {
    marginTop: 30,
    paddingBottom: 60
  },
  reportSection: {
    display: 'grid',
    columnGap: '32px',
    gridTemplateColumns: '1fr 450px'
  }
})

export default useStyles
